import { render } from "./ToDoBrowser.vue?vue&type=template&id=2029d68c"
import script from "./ToDoBrowser.vue?vue&type=script&lang=js"
export * from "./ToDoBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/ToDo/ToDoBrowser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2029d68c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2029d68c', __exports__)) {
    console.log('reload')
    api.reload('2029d68c', __exports__)
  }
  
  module.hot.accept("./ToDoBrowser.vue?vue&type=template&id=2029d68c", () => {
    console.log('re-render')
    api.rerender('2029d68c', render)
  })

}


export default __exports__